import type React from "react";
import { useTranslation } from "react-i18next";
import useNetworkStatus from "src/capacitor/useNetworkStatus";
import { PrimaryButton } from "src/components/Default/LekUI/Button";
import {
	Modal,
	ModalContent,
	ModalFooter,
	ModalTitle,
} from "src/components/Modals/Components/ModalsComponents";
import NetworkProblemIcon from "src/images/Icons/newIcons/networkProblem.svg";
import { ModalMaxWidth } from "src/types/enums";

interface NetworkErrorModalWrapperProps {
	children: React.ReactNode;
}

export const NetworkErrorModalWrapper = ({ children }: NetworkErrorModalWrapperProps) => {
	const { t } = useTranslation();
	const connection = useNetworkStatus();

	const refresh = async () => {
		location.reload();
	};

	if (!connection) {
		return null;
	}

	if (connection.connected) {
		return children;
	}

	return (
		<Modal maxWidth={ModalMaxWidth.sm}>
			<ModalTitle
				title={t("modals.networkError.header")}
				Icon={NetworkProblemIcon}
			/>
			<ModalContent>
				<p className="m-0 text-grey text-center">
					{t("modals.networkError.subheader1")}{" "}
					{t("modals.networkError.subheader2")}
				</p>
			</ModalContent>
			<ModalFooter>
				<PrimaryButton onClick={refresh}>{t("commands.refresh")}</PrimaryButton>
			</ModalFooter>
		</Modal>
	);
};
